module.exports = {"school-name":"Boise State University","logo":"/sites/bsu/logo.png","footer-header-bg":"/sites/bsu/footer-header-bg.png","logout-color":"#d64208","logout-font-color":"#fff","header-color":"","header-main":"/sites/bsu/header.jpg","footer-logo":"/sites/bsu/footer-header-bg.png","footer-wrap":"/sites/bsu/footer-bg-repeat.jpg","footer-color":"","footer-info":"© 2018 Boise State University 1910 University Dr., Boise, ID 83725 (208) 426-1000","help-button-color":"#D64309","help-button-font-color":"#fff"}


//////////////////
// WEBPACK FOOTER
// ./sites/bsu/site-config.json
// module id = 116
// module chunks = 12